// PRD 76: error payload returned by the backend when a roast write would
// exceed the per-cycle quota. Shared by the single and bulk create flows.
export interface QuotaExceededPayload {
  error: 'subscription.quota_exceeded';
  tier: string;
  limit_kg: number;
  used_kg: number;
  requested_kg: number;
  cycle_end: string;
}

export const isQuotaExceededError = (
  err: unknown,
): err is { response: { data: QuotaExceededPayload } } => {
  const payload = (err as { response?: { data?: { error?: unknown } } })?.response?.data;
  return !!payload && payload.error === 'subscription.quota_exceeded';
};
